/**
 * ConsentHandler Object
 */
import { EDestinationType } from '../../interfaces';

export type TConsentSettings = Record<string, any>;

export type TConsentResult = {
  consentAllowsSending: boolean;
  consentValue: EConsentValue;
};

export enum EConsentValue {
  ACCEPTED = 'accepted',
  DENIED = 'denied',
  NO_DECISION = 'no_decision', // when consent banner has loaded but no decision was given should we use this?
  NOT_LOADED = 'not_loaded', // when no banner has been loaded? Dont use this for now
}

export enum EConsentSource {
  BEE_CLEVER = 'bee_clever',
  CONSENT_MO = 'consent_mo',
  CUSTOM = 'custom',
  NONE = 'none',
  PANDECTES = 'pandectes',
  SW5_STANDARD = 'sw5_standard',
  // Add more sources as needed

  SW6_STANDARD = 'sw6_standard',
  USERCENTRICS = 'usercentrics',

  // Add more sources as needed
}

export type TConsentMap = {
  [key in EDestinationType | 'all']?: EConsentValue;
};

export type TConsentData = {
  consentMap: TConsentMap;
  source: EConsentSource;
};
